"use client";
import React from "react";
import InsightsData from "./InsightsData";
import InsightsPrice from "./InsightsPrice";

const Insights = () => {
  return (
    <div className="m-4">
      <p className="mb-4 font-bold text-2xl">Insights</p>
      <div className="flex gap-4">
        <InsightsPrice />
        <InsightsData />
      </div>
    </div>
  );
};

export default Insights;
